import { render, staticRenderFns } from "./ChatPage.vue?vue&type=template&id=c50d7158&scoped=true&"
import script from "./ChatPage.vue?vue&type=script&lang=js&"
export * from "./ChatPage.vue?vue&type=script&lang=js&"
import style0 from "./ChatPage.vue?vue&type=style&index=0&id=c50d7158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50d7158",
  null
  
)

export default component.exports